<template>
  <div class="carousel">
    <div @click="prevSlide" class="carousel-prev-icon-left"></div>
    <div class="carousel-slides">
      <img
        v-for="(image, index) in images"
        :key="index"
        :src="image"
        :style="{ left: index * 100 + '%', transform: dynamicstyle }"
        alt="暂无图片"
      />
    </div>

    <div @click="nextSlide" class="carousel-prev-icon-right"></div>
    <div class="Indicationpoint">
      <div
        :class="['pointItem', currentSlide == index ? 'pointItemSelected' : '']"
        v-for="(item, index) in images"
        :key="index"
        @click="setSlide(index)"
      >
        {{ index + 1 }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    isDesktop: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      images: [
        'https://ywgimg.yiwugo.com/mag/20240102/h320HQw9Zp8eLtLF.jpg?x-oss-process=image/resize,w_750,h_750',
        require('@/assets/Home/index.jpg'),
        require('@/assets/Home/index2.jpg'),
        // 'https://ywgimg.yiwugo.com/mag/20240510/Pf4xlQycyuFSHxTM.jpg?x-oss-process=image/resize,w_750,h_750',
        // 'http://115.159.84.69:3858/imageszip/1711357341806-.jpg',
        // ... 更多图片
      ],
      dynamicstyle: '', //动态样式
      currentSlide: 0, //播放序号
      interval: Object,
    };
  },
  mounted() {
    // 自动播放动画
    this.startSlideshow();
  },
  methods: {
    setSlide(index) {
      this.currentSlide = index;
      this.setStyle();
      clearInterval(this.interval);
      this.startSlideshow();
    },
    nextSlide() {
      // 每次指针加一
      this.currentSlide = (this.currentSlide + 1) % this.images.length;
      this.setStyle();
    },
    prevSlide() {
      // 每次减一，为负数时循环
      this.currentSlide =
        (this.currentSlide - 1 + this.images.length) % this.images.length;
      this.setStyle();
    },
    // 图片动画
    setStyle() {
      this.dynamicstyle = `translatex(-${this.currentSlide * 100}%)`;
    },
    // 定时器
    startSlideshow() {
      this.interval = setInterval(() => {
        this.currentSlide = (this.currentSlide + 1) % this.images.length;
        this.setStyle();
      }, 3000);
    },
    stopSlideshow() {
      clearInterval(this.interval);
    },
  },
};
</script>
<style scoped lang="less">
.carousel {
  position: relative;
}
.carousel-slides {
  position: relative;
  // width: 880px;
  width: 100%;
  height: 20vh;
  overflow: hidden;
}
.carousel-slides img {
  display: inline-block;
  position: absolute;
  width: inherit;
  margin: 0;
  padding: 0;
  top: 0;
  left: 0;
  height: 100%;
  transition: 0.5s transform ease-in-out;
}
.carousel-controls {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
}
.carousel-prev-icon-left {
  position: absolute;
  left: 10px;
  top: 55px;
  height: 50px;
  width: 40px;
  border: none;
  /* background-image: url(../../../assets/img/arrow-l.png); */
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 3;
}
.carousel-prev-icon-right {
  position: absolute;
  right: 10px;
  top: 55px;
  height: 50px;
  width: 40px;
  border: none;
  /* background-image: url('../../../assets/img/arrow-r.png/'); */
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 3;
}
.Indicationpoint {
  position: absolute;
  right: 30px;
  bottom: 20px;
  width: 100px;
  height: 20px;
  // border: 1px solid red;

  display: flex;
  justify-content: space-around;
  .pointItem {
    border-radius: 50%;
    // border: 3px solid rgba(255, 255, 255, 0.3);
    width: 20px;
    height: 20px;
    background-color: #fff;
    color: #f60;
    line-height: 20px;
    text-align: center;
    font-size: 12px;
    cursor: pointer;
  }
  .pointItemSelected {
    background-color: #f60;
    color: #fff;
  }
}
</style>
